import { RentTab } from "./tabs/rent"
import { IndicationTab } from "./tabs/indication"
import { usePageTitle } from "../../hooks"
import { TabsComponent } from "../../components/tabs"
import useAuth from "../../context/auth"

export const Dashboard = () => {
    usePageTitle("Dashboard")

    const { tab, setTab } = useAuth()

    return (
        <>
            <TabsComponent
                items={[
                    {
                        label: "Diárias",
                        value: 0,
                    },
                    {
                        label: "Indique e ganhe",
                        value: 1,
                    },
                ]}
                value={tab}
                onChange={setTab}
            />
            {tab === 0 && <RentTab />}
            {tab === 1 && <IndicationTab />}
        </>
    )
}